// 大阿爾克那 (Major Arcana) - 22張
// 使用 Wikipedia Commons 的官方 Rider-Waite Tarot 圖庫（最穩定且完整）
const majorArcanaImages = {
  0: 'https://upload.wikimedia.org/wikipedia/commons/9/90/RWS_Tarot_00_Fool.jpg',
  1: 'https://upload.wikimedia.org/wikipedia/commons/d/de/RWS_Tarot_01_Magician.jpg',
  2: 'https://upload.wikimedia.org/wikipedia/commons/8/88/RWS_Tarot_02_High_Priestess.jpg',
  3: 'https://upload.wikimedia.org/wikipedia/commons/d/d2/RWS_Tarot_03_Empress.jpg',
  4: 'https://upload.wikimedia.org/wikipedia/commons/c/c3/RWS_Tarot_04_Emperor.jpg',
  5: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/RWS_Tarot_05_Hierophant.jpg',
  6: 'https://upload.wikimedia.org/wikipedia/commons/3/3a/TheLovers.jpg',
  7: 'https://upload.wikimedia.org/wikipedia/commons/9/9b/RWS_Tarot_07_Chariot.jpg',
  8: 'https://upload.wikimedia.org/wikipedia/commons/f/f5/RWS_Tarot_08_Strength.jpg',
  9: 'https://upload.wikimedia.org/wikipedia/commons/4/4d/RWS_Tarot_09_Hermit.jpg',
  10: 'https://upload.wikimedia.org/wikipedia/commons/3/3c/RWS_Tarot_10_Wheel_of_Fortune.jpg',
  11: 'https://upload.wikimedia.org/wikipedia/commons/e/e0/RWS_Tarot_11_Justice.jpg',
  12: 'https://upload.wikimedia.org/wikipedia/commons/2/2b/RWS_Tarot_12_Hanged_Man.jpg',
  13: 'https://upload.wikimedia.org/wikipedia/commons/d/d7/RWS_Tarot_13_Death.jpg',
  14: 'https://upload.wikimedia.org/wikipedia/commons/f/f8/RWS_Tarot_14_Temperance.jpg',
  15: 'https://upload.wikimedia.org/wikipedia/commons/5/55/RWS_Tarot_15_Devil.jpg',
  16: 'https://upload.wikimedia.org/wikipedia/commons/5/53/RWS_Tarot_16_Tower.jpg',
  17: 'https://upload.wikimedia.org/wikipedia/commons/d/db/RWS_Tarot_17_Star.jpg',
  18: 'https://upload.wikimedia.org/wikipedia/commons/7/7f/RWS_Tarot_18_Moon.jpg',
  19: 'https://upload.wikimedia.org/wikipedia/commons/1/17/RWS_Tarot_19_Sun.jpg',
  20: 'https://upload.wikimedia.org/wikipedia/commons/d/dd/RWS_Tarot_20_Judgement.jpg',
  21: 'https://upload.wikimedia.org/wikipedia/commons/f/ff/RWS_Tarot_21_World.jpg'
};

export const majorArcana = [
  {
    id: 0,
    name: '愚者',
    nameEn: 'The Fool',
    img: majorArcanaImages[0],
    upright: {
      keywords: ['新起點', '冒險', '純真', '無限可能'],
      meaning: '這是一個全新的開始。愚者鼓勵你放下過去的包袱,帶著純粹的心去體驗未知。'
    },
    reversed: {
      keywords: ['魯莽', '過度天真', '錯失良機'],
      meaning: '你可能正在逃避某些現實,或者在沒有準備好的情況下衝動行事。'
    }
  },
  {
    id: 1,
    name: '魔術師',
    nameEn: 'The Magician',
    img: majorArcanaImages[1],
    upright: {
      keywords: ['創造力', '意志力', '顯化', '資源充足'],
      meaning: '你已經擁有了實現目標所需的一切工具與資源。現在是將想法化為現實的最佳時機。'
    },
    reversed: {
      keywords: ['才華浪費', '操控', '缺乏自信'],
      meaning: '你可能正在懷疑自己的能力,或是把天賦用在了錯誤的地方。'
    }
  },
  {
    id: 2,
    name: '女祭司',
    nameEn: 'The High Priestess',
    img: majorArcanaImages[2],
    upright: {
      keywords: ['直覺', '潛意識', '神秘', '內在智慧'],
      meaning: '現在不是向外尋求答案的時候,請向內看。你的直覺已經知道該怎麼做,安靜下來傾聽。'
    },
    reversed: {
      keywords: ['忽視直覺', '表面化', '隱藏的秘密'],
      meaning: '你可能因為過度依賴邏輯而忽略了內心的警告。是時候誠實面對感受了。'
    }
  },
  {
    id: 3,
    name: '皇后',
    nameEn: 'The Empress',
    img: majorArcanaImages[3],
    upright: {
      keywords: ['豐盛', '孕育', '母性', '自然'],
      meaning: '這是一段充滿愛與豐盛的時期。去照顧自己,享受生活中的美好事物,讓創造力流淌。'
    },
    reversed: {
      keywords: ['依賴', '創意枯竭', '過度保護'],
      meaning: '你可能在人際關係中失去了自我,或者忘記了照顧自己的需求。'
    }
  },
  {
    id: 4,
    name: '皇帝',
    nameEn: 'The Emperor',
    img: majorArcanaImages[4],
    upright: {
      keywords: ['秩序', '權威', '結構', '領導力'],
      meaning: '現在需要建立規則與秩序。運用你的理智與邏輯來掌控局面,穩定的基礎將幫助你走得更遠。'
    },
    reversed: {
      keywords: ['控制狂', '固執', '濫用權力'],
      meaning: '你可能對某些事情抓得太緊,導致自己或他人感到窒息。需要尋找控制與放手的平衡。'
    }
  },
  {
    id: 5,
    name: '教皇',
    nameEn: 'The Hierophant',
    img: majorArcanaImages[5],
    upright: {
      keywords: ['傳統', '精神信仰', '教育', '指引'],
      meaning: '遵循傳統或尋求專業人士的建議會對你有所幫助。這也是學習與傳承知識的好時機。'
    },
    reversed: {
      keywords: ['叛逆', '打破常規', '盲從'],
      meaning: '你正在質疑現有的體制或規則。打破框架是好事,但要確保不是為了反對而反對。'
    }
  },
  {
    id: 6,
    name: '戀人',
    nameEn: 'The Lovers',
    img: majorArcanaImages[6],
    upright: {
      keywords: ['愛', '和諧', '價值觀契合', '重大選擇'],
      meaning: '這關乎一段深刻的關係,也代表著一個需要你依循內心真實價值觀做出的重大抉擇。'
    },
    reversed: {
      keywords: ['失衡', '錯誤的選擇', '價值觀衝突'],
      meaning: '關係中可能出現了裂痕,或者你正在做出違背良心的選擇。請重新審視什麼最重要。'
    }
  },
  {
    id: 7,
    name: '戰車',
    nameEn: 'The Chariot',
    img: majorArcanaImages[7],
    upright: {
      keywords: ['決心', '意志力', '克服困難', '勝利'],
      meaning: '只要你保持專注並駕馭內心的衝突,你將能克服眼前的障礙,獲得最終的勝利。'
    },
    reversed: {
      keywords: ['失控', '方向感喪失', '阻礙'],
      meaning: '你可能感覺局勢正在失控,或者被外在的阻礙拖住了腳步。先停下來,重新找回掌控權。'
    }
  },
  {
    id: 8,
    name: '力量',
    nameEn: 'Strength',
    img: majorArcanaImages[8],
    upright: {
      keywords: ['勇氣', '耐心', '內在力量', '包容'],
      meaning: '真正的力量不是來自於暴力,而是來自於耐心與愛。用溫柔去安撫內心的野獸。'
    },
    reversed: {
      keywords: ['自我懷疑', '脆弱', '恐懼'],
      meaning: '你可能正在被自我懷疑吞噬。記住,脆弱並不可恥,接納軟弱才是找回力量的第一步。'
    }
  },
  {
    id: 9,
    name: '隱者',
    nameEn: 'The Hermit',
    img: majorArcanaImages[9],
    upright: {
      keywords: ['內省', '孤獨', '尋求真理', '沉澱'],
      meaning: '現在是從喧囂中退出的時候。獨處能幫助你聽見靈魂的聲音,答案已經在你心中。'
    },
    reversed: {
      keywords: ['過度孤立', '逃避現實', '寂寞'],
      meaning: '你可能把自己封閉得太久了,導致與世界脫節。走出洞穴接受他人的關心並不會傷害你。'
    }
  },
  {
    id: 10,
    name: '命運之輪',
    nameEn: 'Wheel of Fortune',
    img: majorArcanaImages[10],
    upright: {
      keywords: ['轉機', '命運', '循環', '幸運'],
      meaning: '命運的齒輪正在轉動,生活將迎來不可避免的改變。順應這股潮流,好運正在向你走來。'
    },
    reversed: {
      keywords: ['厄運', '抗拒改變', '低谷'],
      meaning: '事情可能沒有按照預期發展。與其抱怨命運不公,不如思考這次的低谷想教會你什麼。'
    }
  },
  {
    id: 11,
    name: '正義',
    nameEn: 'Justice',
    img: majorArcanaImages[11],
    upright: {
      keywords: ['公平', '因果', '真相', '平衡'],
      meaning: '你過去的選擇造就了現在的結果。保持客觀與誠實,正義最終會得到伸張。'
    },
    reversed: {
      keywords: ['不公', '逃避責任', '欺騙'],
      meaning: '你可能遭受了不公平的對待,或是你在某件事上欺騙了自己。'
    }
  },
  {
    id: 12,
    name: '倒吊人',
    nameEn: 'The Hanged Man',
    img: majorArcanaImages[12],
    upright: {
      keywords: ['暫停', '換位思考', '犧牲', '放下'],
      meaning: '事情似乎停滯不前,但這其實是宇宙在強迫你停下來。換個角度看世界,你會獲得頓悟。'
    },
    reversed: {
      keywords: ['無謂的犧牲', '抗拒暫停', '鑽牛角尖'],
      meaning: '你可能正在做無意義的犧牲,或是對某個無法改變的結果死抓著不放。'
    }
  },
  {
    id: 13,
    name: '死神',
    nameEn: 'Death',
    img: majorArcanaImages[13],
    upright: {
      keywords: ['結束', '轉變', '重生', '不可逆的改變'],
      meaning: '不要害怕,這不是肉體的死亡,而是舊事物的終結。讓不適合的東西離開,生機才會到來。'
    },
    reversed: {
      keywords: ['抗拒改變', '停滯', '無法放手'],
      meaning: '你正在緊緊抓住那些早該結束的關係或事物。抗拒改變只會帶來更多的痛苦。'
    }
  },
  {
    id: 14,
    name: '節制',
    nameEn: 'Temperance',
    img: majorArcanaImages[14],
    upright: {
      keywords: ['平衡', '融合', '耐心', '療癒'],
      meaning: '這是一個尋求生活平衡與內心平靜的時期。避免極端,將不同的元素調和,找到最佳狀態。'
    },
    reversed: {
      keywords: ['失衡', '極端', '衝突'],
      meaning: '你的生活可能處於某種極端狀態,不是太過就是不及。你需要重新調整步調。'
    }
  },
  {
    id: 15,
    name: '惡魔',
    nameEn: 'The Devil',
    img: majorArcanaImages[15],
    upright: {
      keywords: ['束縛', '成癮', '物質主義', '誘惑'],
      meaning: '你可能感覺自己被某種有害的關係或習慣困住了。但請記得,困住你的鎖鏈並沒有上鎖。'
    },
    reversed: {
      keywords: ['掙脫束縛', '重獲自由', '覺醒'],
      meaning: '恭喜你,你正在意識到自己的毒性模式,並準備從中解脫。這是一個重獲自由的時刻。'
    }
  },
  {
    id: 16,
    name: '高塔',
    nameEn: 'The Tower',
    img: majorArcanaImages[16],
    upright: {
      keywords: ['劇變', '崩潰', '突如其來', '覺醒'],
      meaning: '建立在虛假基礎上的事物正在崩塌。這是一個震撼的過程,但毀滅之後才能在真實中重建。'
    },
    reversed: {
      keywords: ['逃避災難', '推遲改變', '恐懼崩潰'],
      meaning: '你看到了危機,卻試圖掩蓋它。拖延只會讓壓力越來越大,勇敢面對即將倒塌的塔吧。'
    }
  },
  {
    id: 17,
    name: '星星',
    nameEn: 'The Star',
    img: majorArcanaImages[17],
    upright: {
      keywords: ['希望', '療癒', '靈感', '平靜'],
      meaning: '在經歷了暴風雨後,星星為你帶來了希望與療癒。你的心靈正在恢復,未來充滿光明。'
    },
    reversed: {
      keywords: ['絕望', '失去信仰', '悲觀'],
      meaning: '你可能暫時失去了對未來的希望,感覺被宇宙拋棄。請相信星星依然在那裡。'
    }
  },
  {
    id: 18,
    name: '月亮',
    nameEn: 'The Moon',
    img: majorArcanaImages[18],
    upright: {
      keywords: ['恐懼', '幻覺', '潛意識', '不安'],
      meaning: '事情並不像表面看起來那樣。潛意識正在浮現,帶來不安。相信直覺,慢慢走過黑暗。'
    },
    reversed: {
      keywords: ['真相大白', '克服恐懼', '揭露秘密'],
      meaning: '迷霧正在散去,隱藏的真相終於浮出水面。你正在克服內心的恐懼,找回方向感。'
    }
  },
  {
    id: 19,
    name: '太陽',
    nameEn: 'The Sun',
    img: majorArcanaImages[19],
    upright: {
      keywords: ['快樂', '成功', '生命力', '正面能量'],
      meaning: '這是一張充滿絕對正面能量的牌。所有的陰霾都被驅散,享受這份純粹的快樂與溫暖吧!'
    },
    reversed: {
      keywords: ['暫時的悲傷', '缺乏熱情', '過度樂觀'],
      meaning: '陽光暫時被遮住了,你可能感覺不到快樂,或者對事情過於天真。但太陽總會再次升起。'
    }
  },
  {
    id: 20,
    name: '審判',
    nameEn: 'Judgement',
    img: majorArcanaImages[20],
    upright: {
      keywords: ['覺醒', '重生', '內在呼喚', '重大決斷'],
      meaning: '你聽到了一個來自靈魂深處的呼喚。是時候原諒過去的自己,做出改變一生的決定。'
    },
    reversed: {
      keywords: ['自我懷疑', '拒絕呼喚', '悔恨'],
      meaning: '你可能因為害怕而拒絕了改變的機會,或者對過去充滿悔恨。放過自己吧。'
    }
  },
  {
    id: 21,
    name: '世界',
    nameEn: 'The World',
    img: majorArcanaImages[21],
    upright: {
      keywords: ['圓滿', '完成', '整合', '成就'],
      meaning: '一個重要的生命週期已經完美結束。你整合了過去的所有經驗,達到了圓滿的狀態。'
    },
    reversed: {
      keywords: ['未完成', '停滯', '空虛感'],
      meaning: '你距離終點只有一步之遙,但似乎卡住了。找出那個還沒解開的結,完成它。'
    }
  }
];